import React, { useEffect} from 'react'
import styles from './Table.module.css'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { CSVLink } from "react-csv";

import { useSelector } from 'react-redux'
import { getResponses } from '../../actions/responses'


const Table = () => {

    const dispatch = useDispatch()
    const history = useHistory()
    const user = JSON.parse(localStorage.getItem('profile'))
    const allResponses = useSelector(state => state.responses)

    console.log(allResponses)

    useEffect(() => {
        dispatch(getResponses())
    }, [dispatch])


    // React CSV
    const headers = [
        { label: "user", key: "user" },
        { label: "commonName", key: "commonName" },
        { label: "scientificName", key: "scientificName" },
        { label: "Location", key: "location" },
        { label: "Size", key: "size" },
        { label: "MainColors", key: "mainColors" },
        { label: "headColor", key: "headColor" },
        { label: "upperColor", key: "upperColor" },
        { label: "bellyColor", key: "bellyColor" },
        { label: "billShape", key: "billShape" },
        { label: "tailShape", key: "tailShape" },
        { label: "Date", key: "createdAt" },
      ];
      
      const csvReport = {
        data: allResponses,
        headers: headers,
        filename: 'UserResponses.csv'
      };
    

    return (
        <div>
            {
                user.result?.role !== 'admin' ? (<div>{history.push('/')}</div>) :
                (
            <div className={styles.container}>
                <h3 className={styles.title}>Activity log</h3>

                <table id="customers">
  <tr>
    <th>User</th>
    <th>Species</th>
    <th>scientificName</th>
    <th>location</th>
    <th>Size</th>
    <th>MainColors</th>
    <th>headColor</th>
    <th>upperColor</th>
    <th>bellyColor</th>
    <th>billShape</th>
    <th>tailShape</th>
    <th>Date</th>
  </tr>
    {
        allResponses.map((response) => (
            <tr>
                <td>{response.user}</td>
                <td>{response.commonName}</td>
                <td className={styles.italize}>{response.scientificName}</td>
                <td>{response.location}</td>
                <td>{response.size}</td>
                <td>{response.mainColors.map((color)=> <span key={color}>{color}, </span>)}</td>
                <td>{response.headColor}</td>
                <td>{response.upperColor}</td>
                <td>{response.bellyColor}</td>
                <td>{response.billShape}</td>
                <td>{response.tailShape}</td>
                <td>{response.createdAt}</td>
            </tr>
        ))
    }
</table>

</div>
    )
}

<button className={styles.export}>
    <CSVLink {...csvReport}>Export to CSV</CSVLink>
</button>
</div>

    )
}

export default Table
